import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/specified_residence_card.png")